import React from 'react';
import PropTypes from 'prop-types';
import { Stack } from '@metarouter-private/mr-mui';

import AuditLogFieldHeaderRow from './AuditLogFieldHeaderRow';
import AuditLogFieldRow from './AuditLogFieldRow';
import AuditLogComplexFieldRow from './AuditLogComplexFieldRow';

export default function AuditLogFieldDiffList({ fields }) {
  return (
    <Stack spacing={1}>
      <AuditLogFieldHeaderRow />
      {fields.map(field =>
        field.complex ? (
          <AuditLogComplexFieldRow key={field.key} field={field} />
        ) : (
          <AuditLogFieldRow key={field.key} field={field} />
        )
      )}
    </Stack>
  );
}

AuditLogFieldDiffList.propTypes = {
  fields: PropTypes.array.isRequired,
};
